// import Swiper JS
import Swiper from 'swiper/bundle';

jQuery(document).ready(function() {
    var menuMobile = document.getElementById('menuMobile');
    var hamburger = document.getElementById('hamburger');
    var closeMenuBtn = document.getElementById('closeMobileMenu');
    var socials = document.getElementById('socials');
    var menuSocials = document.getElementById('menuSocials');
    var closeSocialsMenuBtn = document.getElementById('closeSocialsMenu');

    if(hamburger != null && menuMobile != null){
        hamburger.addEventListener('click', function(){
            if (menuSocials != null){
                menuSocials.classList.remove('active-menu');
            }
            menuMobile.classList.add('active-menu');
        });

        if(closeMenuBtn != null){
            closeMenuBtn.addEventListener('click', function(){
                menuMobile.classList.remove('active-menu');
            });
        }
    }

    if (socials != null && menuSocials != null){
        socials.addEventListener('click', function(){
            if(menuMobile != null){
                menuMobile.classList.remove('active-menu');
            }
            menuSocials.classList.add('active-menu');
        });

        if(closeSocialsMenuBtn != null){
            closeSocialsMenuBtn.addEventListener('click', function(){
                menuSocials.classList.remove('active-menu');
            });
        }
    }


    $(document).ready(function(){

        // Add smooth scrolling to all links
        $("a.to-top-page--text").on('click', function(event) {

            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "") {
                // Prevent default anchor click behavior
                event.preventDefault();

                // Store hash
                var hash = this.hash;

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $('html, body').animate({
                    scrollTop: $(hash).offset().top
                }, 800, function(){

                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;
                });
            } // End if
        });
    });


    var readMoreBtn = document.getElementById('readMoreBtn');

    if(readMoreBtn){
    readMoreBtn.addEventListener('click', function(){
        var content = document.querySelectorAll('.value--text p');
        content.forEach(function(text){
            if(text.style.maxHeight){
                text.style.maxHeight = null;
                readMoreBtn.innerText = "Skaityti daugiau";
                text.style.marginBottom = '0px';
            }else{
                text.style.maxHeight = text.scrollHeight + 'px';
                readMoreBtn.innerText = "Skaityti mažiau";
                text.style.marginBottom = '25px';
            }

        })
    });
    }

    var teachersReadMoreBtn = document.querySelectorAll('#techer-read-more');

    teachersReadMoreBtn.forEach(function(elem){
        elem.addEventListener('click', function(){
            var techerDescription = this.previousElementSibling;
            console.log(techerDescription);
            if(techerDescription.style.maxHeight){
                techerDescription.style.maxHeight = null;
                this.innerText = "Skaityti daugiau";
            }else{
                techerDescription.style.maxHeight = techerDescription.scrollHeight + 'px';
                this.innerText = "Skaityti mažiau";
            }
        });
    });



    var newsReadMore = document.querySelectorAll('#newsReadMoreBtn');
    newsReadMore.forEach(function(element){
        element.addEventListener('click', function(){
            var newsFullContent = this.previousElementSibling;
            if(newsFullContent.style.maxHeight){
                newsFullContent.style.maxHeight = null;
                this.innerText = "Skaityti daugiau";
            } else{
                newsFullContent.style.maxHeight = newsFullContent.scrollHeight + 'px';
                this.innerText = "Skaityti mažiau";
            }
        });
    });

// Main banner slider.

    if ($('div[class*="main-slider-"]').length > 0) {
        $('div[class*="main-slider-"]').each(function () {
            let slider_selector = '.main-slider-' + $(this).data('section-key');
            new Swiper(slider_selector, {
                speed: 4000,
                slidesPerView: 1,
                loop: true,
                autoplay: {
                    delay: 8600,
                },
                pagination: {
                    el: '.main-slider.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });
        });
    }

// Section sliders.

    if ($('div[class*="section-slider-"]').length > 0) {
        $('div[class*="section-slider-"]').each(function () {
            let slider_selector = '.section-slider-' + $(this).data('section-key');
            new Swiper(slider_selector, {
                speed: 2000,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 30,
                autoplay: {
                    delay: 8600,
                },
                pagination: {
                    el: $(slider_selector).find('.swiper-pagination')[0],
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2
                    },
                    767: {
                        slidesPerView: 3
                    },
                },
            });
        });
    }

    // Section posts sliders.

    if ($('div[class*="section-posts-slider-"]').length > 0) {
        $('div[class*="section-posts-slider-"]').each(function () {
            console.log($(this).data('grid-display'));
            let slider_selector = '.section-posts-slider-' + $(this).data('section-key');
            new Swiper(slider_selector, {
                speed: 2000,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 30,
                autoplay: {
                    delay: 8600,
                },
                pagination: {
                    el: $(slider_selector).find('.swiper-pagination')[0],
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2
                    },
                    767: {
                        slidesPerView: 3
                    },
                },
            });
        });
    }

    // Section image gallery sliders.

    if ($('div[class*="section-image-gallery-slider-"]').length > 0) {
        $('div[class*="section-image-gallery-slider-"]').each(function () {
            let slider_selector = '.section-image-gallery-slider-' + $(this).data('section-key');
            new Swiper(slider_selector, {
                speed: 2000,
                slidesPerView: 1,
                slidesPerGroup: 1,
                loop: false,
                spaceBetween: 30,
                autoplay: {
                    delay: 8600,
                },
                pagination: {
                    el: $(slider_selector).find('.swiper-pagination')[0],
                    type: 'bullets',
                    clickable: true,
                },
                breakpoints: {
                    480: {
                        slidesPerView: 2
                    },
                    767: {
                        slidesPerView: 3
                    },
                },
            });
        });
    }

    // Youtube players.
    if ($('.youplay').length > 0) {
        var player;

        function onYouTubeIframeAPIReady() {

            $('.youplay').each(function (index) {
                let video_id = $(this).data('video-id');
                let player_id = $(this).attr('id');
                player = new YT.Player(player_id, {
                    height: '360',
                    width: '640',
                    videoId: video_id,
                    playerVars: {
                        'playsinline': 1,
                        'rel': 0,
                        'controls': 1,
                        'showinfo': 0,
                        'autoplay': 0,
                        'loop': 0,
                        'modestbranding': 1,
                        'cc_load_policy': 0,
                        'enablejsapi': 1,
                        'iv_load_policy': 3
                    },
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });

                // 4. The API will call this function when the video player is ready.
                function onPlayerReady(event) {
                    
                    // event.target.playVideo();
                }

                var done = false;
                function onPlayerStateChange(event) {
                    if (event.data == YT.PlayerState.ENDED) {
                        stopVideo();
                        done = true;
                    }
                }
                function stopVideo() {
                    player.stopVideo();
                }
                pause_youtube_player(player, player_id);
            });
        }

        window.YT.ready(function () {
            onYouTubeIframeAPIReady();
        });

        function pause_youtube_player(player, player_id) {
            $(document).on('scroll', function (element) {
                let element_selector = "#" + player_id;
                const rect = $(element_selector)[0].getBoundingClientRect();
                if (typeof player.stopVideo === 'function') {
                    if ((!(rect.bottom > 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight))) && player.getPlayerState() == 1) {
                        player.pauseVideo();
                    }
                }
            });
        }
    }
});








